import { render, staticRenderFns } from "./broker-email.vue?vue&type=template&id=35a40bf4"
import script from "./broker-email.vue?vue&type=script&lang=js"
export * from "./broker-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports